import classNames from 'classnames';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { TitleDescWithColorProps } from 'eco-design-micro/props/msg/TitleDescProps';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import React from 'react';
import './index.scss';

export interface EcoCardsBItemProps extends ImgVideoProps, TitleDescWithColorProps {
    /**
     * 子元素A-在title,desc 之下
     */
    itemChildA?: React.ReactNode;
    /**
     * 子元素B-用于元素内绝对定位
     */
    itemChildB?: React.ReactNode;
}
interface EcoCardsBProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    items: EcoCardsBItemProps[];
}

/**
 * 维护:谢保林
 *
 * 卡片列表
 */
const EcoCardsB: React.FC<EcoCardsBProps> = ({ items, className }) => {
    const prefixCls = `eco-cards-b`;
    const classes = classNames(prefixCls, 'eco-content', {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            {items?.map((item: EcoCardsBItemProps, index: number) => {
                const hasChildA = !!item.itemChildA;
                const hasChildB = !!item.itemChildB;
                return (
                    <div key={index} className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`}>
                        <div className={`${prefixCls}-item-img`}>
                            <EcoImgVideo
                                isVideo={item.isVideo}
                                pc={item.pc}
                                h5={item.h5}
                                poster={item.poster}
                                posterH5={item.posterH5}
                                autoPlay={true}
                                loop={true}
                            />
                        </div>
                        <div className={`${prefixCls}-item-msg`}>
                            {item.title && <div className={`${prefixCls}-item-title`}>{item.title}</div>}
                            {item.desc && <div className={`${prefixCls}-item-desc`}>{item.desc}</div>}
                            {hasChildA && item.itemChildA}
                        </div>
                        {hasChildB && item.itemChildB}
                    </div>
                );
            })}
        </div>
    );
};

export default EcoCardsB;
